import { render, staticRenderFns } from "./ModalCancelarTransferencia.vue?vue&type=template&id=0d677680"
import script from "./ModalCancelarTransferencia.vue?vue&type=script&lang=js"
export * from "./ModalCancelarTransferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports